import { render, staticRenderFns } from "./oss-upload.vue?vue&type=template&id=1ac41382&scoped=true&"
import script from "./oss-upload.vue?vue&type=script&lang=js&"
export * from "./oss-upload.vue?vue&type=script&lang=js&"
import style0 from "./oss-upload.vue?vue&type=style&index=0&id=1ac41382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac41382",
  null
  
)

export default component.exports